<template>
  <ui-dialog show max-width="968px" @input="$emit('close')">
    <template #header>
      <h3>{{ $t("message.posts.fbDialogTitle") }}</h3>
    </template>
    <div class="step-indicator">
      <div
        v-for="step in indicatorSteps"
        :key="step.value"
        class="step-indicator__item"
        :class="{ 'is-active': step.value === currentStep }"
      >
        <div class="step-indicator__circle">{{ step.value }}</div>
        <div class="step-indicator__text">
          {{ step.text }}
        </div>
      </div>
    </div>
    <transition tag="div" name="toggle" mode="out-in">
      <FbPostsDialogPageSelectionView
        v-if="currentStep === 1"
        @next-step="handleNextStep"
      />
      <FbPostsDialogView
        v-else-if="currentStep === 2"
        :page-id="this.selectedPageId"
        @close="$emit('close')"
        @back="currentStep = 1"
        @submit="handleSubmit"
      />
    </transition>
  </ui-dialog>
</template>

<script>
import FbPostsDialogView from "./FbPostsDialogView.vue";
import FbPostsDialogPageSelectionView from "./FbPostsDialogPageSelectionView.vue";
import { GTM_EVENT_NAME } from "@/enums/gtm-events";

export default {
  name: "FbPostsDialog",
  components: {
    FbPostsDialogView,
    FbPostsDialogPageSelectionView
  },
  data() {
    return {
      currentStep: 1,
      selectedPageId: null,
      indicatorSteps: [
        {
          text: this.$t("message.posts.selectPage"),
          value: 1
        },
        {
          text: this.$t("message.posts.selectPost"),
          value: 2
        }
      ]
    };
  },
  methods: {
    handleSubmit(payload) {
      this.$store.dispatch("posts/setFbPostData", {
        ...payload,
        facebook_page_id: this.selectedPageId
      });
      this.$gtm.trackCustomEvent({
        event: GTM_EVENT_NAME.POST_COPY_FROM_FACEBOOK_POST_REUSED
      });
      this.$emit("close");
      this.$router.push({ name: "posts-add", query: { type: "fb" } });
    },
    handleNextStep(selectedPageId) {
      this.$gtm.trackCustomEvent({
        event: GTM_EVENT_NAME.POST_COPY_FROM_FACEBOOK_PAGE_SELECTED
      });
      this.selectedPageId = selectedPageId;
      this.currentStep = 2;
    }
  }
};
</script>
<style lang="scss" scoped>
.toggle-enter-active,
.toggle-leave-active {
  transition: opacity 0.3s;
}

.toggle-enter, .toggle-leave-to /* .fade-leave-active in <2.1.8 */ {
  opacity: 0;
}

.step-indicator {
  display: flex;
  justify-content: space-between;
  margin-bottom: 24px;
  position: relative;

  &:before {
    content: "";
    height: 1px;
    width: 100%;
    position: absolute;
    background: $gray-300;
    top: 0;
    bottom: 0;
    margin: auto;
  }

  &__item {
    display: flex;
    align-items: center;
    gap: $spacing;
    color: $gray-2;
    background: white;
    position: relative;
    z-index: 1;
    padding: 0 $spacing * 2;
    transition: color 0.3s 0.2s;

    &.is-active {
      color: $grey-darker;

      .step-indicator__circle {
        background-color: $primary;
      }
    }
  }

  &__circle {
    width: 26px;
    height: 26px;
    border-radius: 50%;
    background-color: $gray-2;
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    @include font-size(12px);
    transition: background 0.3s 0.2s;
  }
}
</style>
